import { render, staticRenderFns } from "./HeaderControls.vue?vue&type=template&id=673be42a&scoped=true&"
import script from "./HeaderControls.vue?vue&type=script&lang=js&"
export * from "./HeaderControls.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControls.vue?vue&type=style&index=0&id=673be42a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673be42a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673be42a')) {
      api.createRecord('673be42a', component.options)
    } else {
      api.reload('673be42a', component.options)
    }
    module.hot.accept("./HeaderControls.vue?vue&type=template&id=673be42a&scoped=true&", function () {
      api.rerender('673be42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverableTemplates/HeaderControls.vue"
export default component.exports